<template>
  <div>
    <div v-if="!horas.length" class="text-center caption my-6">
      Sin datos para mostrar.
    </div>

    <v-simple-table v-else class="custom-stripped-color no-seleccionable hora-por-hora-table">
      <template v-slot:default>
        <thead>
          <tr class="text-center">
            <th class="font-weight-bold pa-3 custom-background-color max-width-th" rowspan="3">
              Hora
            </th>

            <th
              v-for="cell in topRowCells"
              :key="cell.key"
              class="font-weight-bold pa-3"
              :class="cell.className"
              :colspan="cell.colspan"
            >
              {{ cell.title }}
            </th>

            <th class="font-weight-bold pa-3 custom-background-color" rowspan="3" style="min-width:160px;">
              Tiempo De Paro<br>(HH:MM:SS)
            </th>
            <!-- ✅ AGREGAR -->
            <th v-if="tiempoMuerto" class="font-weight-bold pa-3 custom-background-color" rowspan="3" style="min-width:150px;">
              Tiempo Muerto<br>(HH:MM:SS)
            </th>
            <th class="font-weight-bold pa-3 custom-background-color" rowspan="3">OEE</th>
          </tr>

          <tr class="text-center">
            <th
              v-for="cell in secondRowCells"
              :key="cell.key"
              class="font-weight-bold pa-2"
              :class="cell.className"
              :colspan="cell.colspan"
            >
              {{ cell.label }}
            </th>
          </tr>

          <tr class="text-center counter-font-default-size">
            <th
              v-for="cell in thirdRowCells"
              :key="cell.key"
              class="pa-2 text-center"
              :class="cell.className"
            >
              {{ cell.text }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(h, idx) in horas" :key="'h-' + idx" class="text-center">
            <td class="pa-3 font-weight-medium">
              <div>{{ h.desdeHora }} - {{ h.hastaHora }}</div>
              <div v-if="h.fecha" class="caption">{{ h.fecha }}</div>
            </td>

            <td v-for="col in bodyCols" :key="'b-' + idx + '-' + col.key" :class="['pa-3', col.className]">
              {{ fmt(col.field, cell(h, col.grpId, col.field)) }}
            </td>

            <td class="pa-3 tiempo-paro-cell">
              <ul class="ma-0 pa-0" style="list-style:none;">
                <li><strong>Programados:</strong> <br> {{ fmtSegundos(getParos(h).prog) }}</li>
                <br>
                <li><strong>No programados:</strong> <br> {{ fmtSegundos(getParos(h).noProg) }}</li>
              </ul>
            </td>
            <td v-if="tiempoMuerto" class="pa-3">
              {{ fmtSegundos(h.totalSegundosMuertos) }}
            </td>

            <td class="pa-3">{{ formatOee(rowOee(h)) }}</td>
          </tr>
        </tbody>

        <tfoot>
          <tr class="text-center">
            <td class="font-weight-bold pa-3 custom-background-color white--text">Total</td>

            <td v-for="col in bodyCols" :key="'t-' + col.key" :class="['pa-3', 'font-weight-bold', col.className]">
              {{ fmt(col.field, totalCell(col)) }}
            </td>

            <td class="pa-3 font-weight-bold">
              <v-tooltip top color="black">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{ fmtSegundos((totals.segParoProg || 0) + (totals.segParoNoProg || 0)) }}
                  </span>
                </template>
                <span class="white--text">
                  Paro prog.: {{ fmtSegundos(totals.segParoProg || 0) }}
                  <br>
                  Paro no prog.: {{ fmtSegundos(totals.segParoNoProg || 0) }}
                </span>
              </v-tooltip>
            </td>

            <td v-if="tiempoMuerto" class="pa-3 font-weight-bold">
              {{ fmtSegundos(totals.segMuerto || 0) }}
            </td>

            <td class="pa-3 font-weight-bold">{{ formatOee(totals.oee) }}</td>
          </tr>
        </tfoot>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Object, required: true },
    tiempoMuerto: { type: Boolean, default: false },
    modoGrupo: { type: String, default: 'Cavidades' }, // "Cavidades" | "Articulos"
  },
  data() {
    return {
      headerGroups: [
        { key: 'est', title: 'Esperado', headerClass: 'background-color-estandar', fields: [{ key: 'estHora', label: 'Hora' }, { key: 'estAcum', label: 'Acumulado' }] },
        { key: 'real', title: 'Real', headerClass: 'background-color-real', fields: [{ key: 'realHora', label: 'Hora' }, { key: 'realAcum', label: 'Acumulado' }] },
        { key: 'dif', title: 'Diferencia', headerClass: 'background-color-diferencia', fields: [{ key: 'diffHora', label: 'Hora' }, { key: 'diffAcum', label: 'Acumulado' }] },
        { key: 'nok', title: 'Piezas NO OK', headerClass: 'custom-background-color', fields: [{ key: 'noOk', label: '' }] },
      ],
    }
  },
  computed: {
    isArticulos() {
      return String(this.modoGrupo || '').toLowerCase() === 'articulos'
    },
    horasRaw() {
      return this.p(this.value, ['datosHoraViewModel', 'DatosHoraViewModel']) || []
    },
    metaByOp() {
      const det = this.p(this.value, ['detallesODTOperaciones', 'DetallesODTOperaciones']) || []
      const m = {}
      ;(Array.isArray(det) ? det : []).forEach(d => {
        const idOp = this.p(d, ['idOperacion', 'IdOperacion'])
        if (idOp == null) return
        m[idOp] = {
          idOp,
          idArticulo: this.p(d, ['idArticulo', 'IdArticulo']),
          nombreArticulo: this.p(d, ['nombreArticulo', 'NombreArticulo']),
          nombreToken: this.p(d, ['nombreToken', 'NombreToken']),
          clave: this.p(d, ['clave', 'Clave']),
        }
      })
      return m
    },
    grupos() {
      const opIds = {}
      this.horasRaw.forEach(H => {
        ;(this.p(H, ['operaciones', 'Operaciones']) || []).forEach(op => {
          const id = this.p(op, ['idOperacion', 'IdOperacion'])
          if (id != null) opIds[id] = true
        })
      })

      const ids = Object.keys(opIds).map(Number).sort((a, b) => a - b)
      if (!ids.length) return [{ id: '__default__', name: 'Única', opIds: ['__default__'] }]

      if (!this.isArticulos) {
        return ids.map(id => {
          const meta = this.metaByOp[id] || {}
          const name = meta.nombreToken || meta.clave || meta.nombreArticulo || ('Op ' + id)
          return { id, name, opIds: [id] }
        })
      }

      const map = {}
      ids.forEach(id => {
        const meta = this.metaByOp[id] || {}
        const key = meta.idArticulo != null ? `A:${meta.idArticulo}` : (meta.nombreArticulo ? `AN:${meta.nombreArticulo}` : `O:${id}`)
        const name = meta.nombreArticulo || meta.nombreToken || meta.clave || ('Op ' + id)
        map[key] = map[key] || { id: key, name, opIds: [] }
        map[key].opIds.push(id)
      })

      return Object.values(map).sort((a, b) => String(a.name).localeCompare(String(b.name)))
    },
    grpCount() {
      return this.grupos.length
    },

    topRowCells() {
      const n = this.grpCount || 1
      return this.headerGroups.map(g => ({
        key: 'top-' + g.key,
        title: g.title,
        colspan: g.fields.length * n,
        className: g.headerClass,
      }))
    },
    secondRowCells() {
      const n = Math.max(1, this.grpCount || 1)
      const cells = []
      this.headerGroups.forEach(g => {
        g.fields.forEach(f => {
          cells.push({ key: 'sub-' + g.key + '-' + f.key, label: f.label, colspan: n, className: g.headerClass })
        })
      })
      return cells
    },
    thirdRowCells() {
      const cells = []
      this.headerGroups.forEach(g => {
        g.fields.forEach(f => {
          this.grupos.forEach(gr => {
            cells.push({ key: 'grp-' + g.key + '-' + f.key + '-' + gr.id, text: gr.name, className: g.headerClass + ' white--text' })
          })
        })
      })
      return cells
    },
    bodyCols() {
      const classPerGroup = { est: 'background-color-estandar_row', real: 'background-color-real_row', dif: 'background-color-diferencia_row', nok: '' }
      const cols = []
      this.headerGroups.forEach(g => {
        g.fields.forEach(f => {
          this.grupos.forEach(gr => {
            cols.push({ key: `col-${g.key}-${f.key}-${gr.id}`, grpId: gr.id, field: f.key, className: classPerGroup[g.key] || '' })
          })
        })
      })
      return cols
    },

    horas() {
      const hs = (this.horasRaw || []).slice().sort((a, b) =>
        String(this.p(a, ['inicio', 'Inicio']) || '').localeCompare(String(this.p(b, ['inicio', 'Inicio']) || ''))
      )

      const acc = {}
      this.grupos.forEach(gr => (acc[gr.id] = { e: 0, r: 0 }))

      return hs.map(H => {
        const ini = String(this.p(H, ['inicio', 'Inicio']) || '')
        const fin = String(this.p(H, ['fin', 'Fin']) || '')
        const ops = this.p(H, ['operaciones', 'Operaciones']) || []

        const byId = {}
        ;(Array.isArray(ops) ? ops : []).forEach(op => {
          const id = this.p(op, ['idOperacion', 'IdOperacion'])
          if (id != null) byId[id] = op
        })

        const perGrp = {}
        this.grupos.forEach(gr => {
          let estHora = 0, realHora = 0, noOk = 0

          ;(gr.opIds || []).forEach(idOp => {
            const op = byId[idOp] || {}
            estHora += this.n(this.p(op, ['piezasEsperadasReales', 'PiezasEsperadasReales', 'piezasEsperadas', 'PiezasEsperadas']))
            realHora += this.n(this.p(op, ['piezasOk', 'PiezasOk', 'piezasHechasReales', 'PiezasHechasReales']))
            noOk += this.n(this.p(op, ['piezasNoOk', 'PiezasNoOk', 'piezasNoOkHechasReales', 'PiezasNoOkHechasReales']))
          })

          acc[gr.id].e += estHora
          acc[gr.id].r += realHora

          perGrp[gr.id] = {
            estHora,
            estAcum: acc[gr.id].e,
            realHora,
            realAcum: acc[gr.id].r,
            diffHora: realHora - estHora,
            diffAcum: acc[gr.id].r - acc[gr.id].e,
            noOk,
          }
        })

        const segParoProg = this.n(this.p(H, ['segundosParoProgramadoReal', 'SegundosParoProgramadoReal', 'segundosParoProgramado', 'SegundosParoProgramado']))
        const segParoNoProg = this.n(this.p(H, ['segundosParoNoProgramadoReal', 'SegundosParoNoProgramadoReal', 'segundosParoNoProgramado', 'SegundosParoNoProgramado', 'segundosParo', 'SegundosParo']))
        let segMuerto = this.n(this.p(H, [
          'totalSegundosMuertos',
          'TotalSegundosMuertos',
          'segundosMuertos',
          'SegundosMuertos',
          'tiempoMuertoSeg',
          'TiempoMuertoSeg',
          'segundosTiempoMuerto',
          'SegundosTiempoMuerto',
        ]))
        if (!segMuerto) {
          const roeeSeg = this.p(H, ['resultadosOEE', 'ResultadosOEE']) || {}
          segMuerto = this.n(this.p(roeeSeg, [
            'tiempoMuertoSeg',
            'TiempoMuertoSeg',
            'segundosMuertos',
            'SegundosMuertos',
          ]))
        }

        const resumenHora = this.p(H, ['resumen', 'Resumen']) || {}
        const acumuladoHora = this.p(resumenHora, ['acumulado', 'Acumulado']) || {}
        const roee = this.p(H, ['resultadosOEE', 'ResultadosOEE']) || {}
        const oeeAcumRaw = this.p(acumuladoHora, ['oee', 'Oee'])
        const oeeHoraRaw = this.p(roee, ['oee', 'Oee'])
        const oeeAcumLocal = this.oeeAcumuladoDesdePerGrp(perGrp)
        let oee = 0
        if (oeeAcumRaw != null) oee = this.n(oeeAcumRaw)
        else if (oeeAcumLocal != null) oee = this.n(oeeAcumLocal)
        else if (oeeHoraRaw != null) oee = this.n(oeeHoraRaw)

        return {
          desdeHora: ini ? ini.slice(11, 16) : '',
          hastaHora: fin ? fin.slice(11, 16) : '',
          fecha: ini ? ini.slice(0, 10) : '',
          perGrp,
          segundosParoProgramado: segParoProg,
          segundosParoNoProgramado: segParoNoProg,
          totalSegundosMuertos: segMuerto,
          oee,
        }
      })
    },

    totals() {
      let segParoProg = 0
      let segParoNoProg = 0

      ;(this.horas || []).forEach(h => {
        const p = this.getParos(h)
        segParoProg += p.prog
        segParoNoProg += p.noProg
      })

      // ✅ viene directo del objeto raíz (crudo)
      let segMuerto = this.n(this.p(this.value, [
        'totalSegundosMuertos',
        'TotalSegundosMuertos',
        'segundosMuertos',
        'SegundosMuertos',
        'tiempoMuertoSeg',
        'TiempoMuertoSeg',
        'segundosTiempoMuerto',
        'SegundosTiempoMuerto',
      ]))
      if (!segMuerto) {
        const resumen = this.p(this.value, ['resumen', 'Resumen']) || {}
        segMuerto = this.n(this.p(resumen, [
          'tiempoMuertoSeg',
          'TiempoMuertoSeg',
          'segundosMuertos',
          'SegundosMuertos',
        ]))
      }
      if (!segMuerto) {
        const roeeGlobal = this.p(this.value, ['resultadosOEE', 'ResultadosOEE']) || {}
        segMuerto = this.n(this.p(roeeGlobal, [
          'tiempoMuertoSeg',
          'TiempoMuertoSeg',
          'segundosMuertos',
          'SegundosMuertos',
        ]))
      }

      const horas = this.horas || []
      let oee = this.n(horas.length ? horas[horas.length - 1]?.oee : 0)
      if (!horas.length) {
        const roee = this.p(this.value, ['resultadosOEE', 'ResultadosOEE']) || {}
        oee = this.n(this.p(roee, ['oee', 'Oee']))
      }

      return { segParoProg, segParoNoProg, segMuerto, oee }
    },
  },
  methods: {
    p(o, ks) {
      for (let i = 0; i < ks.length; i++) if (o && o[ks[i]] != null) return o[ks[i]]
      return undefined
    },
    n(v) {
      const x = Number(v)
      return isNaN(x) ? 0 : x
    },

    cell(h, grpId, field) {
      const c = h && h.perGrp ? h.perGrp[grpId] : null
      return c && c[field] != null ? c[field] : 0
    },

    rowOee(h) {
      return this.n(h && h.oee)
    },
    oeeAcumuladoDesdePerGrp(perGrp) {
      const vals = Object.values(perGrp || {})
      const estAcum = vals.reduce((s, g) => s + this.n(g && g.estAcum), 0)
      if (estAcum <= 0) return null
      const realAcum = vals.reduce((s, g) => s + this.n(g && g.realAcum), 0)
      return (realAcum / estAcum) * 100
    },
    formatOee(n) {
      const v = Number(n || 0)
      const r = Math.round(v * 100) / 100
      return r % 1 === 0 ? String(r) : r.toFixed(2)
    },

    getParos(h) {
      const prog = this.n(this.p(h, ['segundosParoProgramado', 'SegundosParoProgramado']))
      const noProg = this.n(this.p(h, ['segundosParoNoProgramado', 'SegundosParoNoProgramado']))
      return { prog, noProg, total: prog + noProg }
    },
    fmtSegundos(s = 0) {
      const t = Math.max(0, Math.floor(Number(s) || 0))
      const h = Math.floor(t / 3600)
      const m = Math.floor((t % 3600) / 60)
      const sec = t % 60
      return [h, m, sec].map(v => String(v).padStart(2, '0')).join(':')
    },

    sumHoras(col, fieldOverride = null) {
      const f = fieldOverride || col.field
      return (this.horas || []).reduce((acc, h) => acc + this.n(this.cell(h, col.grpId, f)), 0)
    },
    totalCell(col) {
      const f = col.field
      if (f === 'estHora' || f === 'realHora' || f === 'diffHora' || f === 'noOk') return this.sumHoras(col)
      if (f === 'estAcum') return this.sumHoras(col, 'estHora')
      if (f === 'realAcum') return this.sumHoras(col, 'realHora')
      if (f === 'diffAcum') return this.sumHoras(col, 'realHora') - this.sumHoras(col, 'estHora')
      return 0
    },
    fmt(field, val) {
      const v = Number(val || 0)
      return ['realHora', 'realAcum', 'diffHora', 'diffAcum'].includes(field)
        ? Math.round(v)
        : v
    },
  },
}
</script>

<style scoped>
.max-width-th { max-width: 80px; }
.custom-background-color { background-color: rgb(42, 96, 153); }
.custom-stripped-color tbody tr:nth-child(odd) { background-color: rgba(42, 96, 153, 0.14); }
.background-color-estandar { background-color: #268db0; }
.background-color-estandar_row { background-color: rgba(38, 141, 176, 0.3); }
.background-color-real { background-color: #993981; }
.background-color-real_row { background-color: rgba(153, 57, 129, 0.3); }
.background-color-diferencia { background-color: #cc6023; }
.background-color-diferencia_row { background-color: rgba(204, 97, 35, 0.4); }
th { text-align: center !important; font-size: 1.0625rem !important; color: white !important; }
tbody tr { text-align: center !important; }
table th+th { border-left: 1px solid #dddddd; }
table td+td { border-left: 1px solid #dddddd; }
.no-seleccionable { -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; }
</style>
<style>
.hora-por-hora-table th,
.hora-por-hora-table td { font-size: 18px !important; }
.hora-por-hora-table td div,
.hora-por-hora-table td span,
.hora-por-hora-table td li,
.hora-por-hora-table td strong { font-size: inherit !important; }
.hora-por-hora-table td.tiempo-paro-cell,
.hora-por-hora-table td.tiempo-paro-cell * { font-size: 1.1em !important; line-height: 1.2; }
</style>
